<template>
  <v-card>
    <router-view :key="$route.fullPath"></router-view>
    <!-- Invoice creation failed warning -->
    <v-dialog v-model="invoiceIssueModal" persistent width="600">
      <v-card>
        <v-card-title class="headline grey lighten-2" primary-title> {{ $t('message.common.warning') }} </v-card-title>
        <v-card-text class="pa-5">
          <h3 class="mt-2" v-if="mailOrEHF === 1">{{ $t('message.invoice.invoiceFailedtoSend') }}</h3>
          <h3 class="mt-2" v-else-if="mailOrEHF === 2">{{ $t('message.invoice.invoiceEHFFailed') }}</h3>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="success" @click="invoiceIssueModal = false">{{ $t('message.common.close') }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-card>
</template>
<script>
export default {
  data () {
    return {
      invoiceIssueModal: false,
      mailOrEHF: 0
    }
  }
}
</script>
